import * as React from 'react';
import Action from './action';
import { ChargeStatus, ChargeTypes } from '@nkr/enums/index';
import { Button } from 'react-bootstrap';

interface IProps {
    donorId: number,
    chargeDescription: string,
    chargeAmount: string | React.ReactNode,
    chargeType: ChargeTypes,
    claimType: {
        isSbs: boolean,
        isMedicare: boolean,
        isMedicaid: boolean,
        isGlobal: boolean
    },
    file: string,
    status: ChargeStatus,
    allowAction: boolean,
    backgroundColor: string,
    isAdmin: boolean,
    onStatusChange: (status: number, chargeType: ChargeTypes) => void,
    onGetDocumentation: (donorId: number, docType: string, fileName: string) => void
}

class ViewChargesTableRow extends React.Component<IProps, {}> {
    handleStatusChange = (status: number) => {
        this.props.onStatusChange(status, this.props.chargeType);
    }

    handleGetDocumentation = (docType: string) => {
        this.props.onGetDocumentation(this.props.donorId, docType, this.props.file);
    }

    getStatusDescription = () => {
        let description = this.props.status == ChargeStatus.Accepted ? 'Accepted' : 'Disputed';
        let className = this.props.status == ChargeStatus.Accepted ? 'text-success' : 'text-danger';

        return <div className={className} style={{ fontWeight: 700 }}>{description}</div>;
    }

    getDocumentationLinks = () => {
        let { isSbs, isMedicare, isMedicaid, isGlobal } = this.props.claimType;

        if (this.props.chargeType == ChargeTypes.PHYSICIAN_CHARGES) {
            if (isSbs) {
                return <span>Prior agreed amount</span>;
            }
        }

        if (this.props.chargeType == ChargeTypes.ANESTHESIA_CHARGES) {
            if (isSbs) {
                return <span>Prior agreed amount</span>;
            }

            if (isGlobal) {
                return <Button bsStyle='link' onClick={() => this.handleGetDocumentation('anesthesia')}>Anesthesia Charges</Button>;
            }
        }

        if (this.props.chargeType == ChargeTypes.HOSPITAL_CHARGES) {
            if (isSbs) {
                return <span>Prior agreed amount</span>;
            }

            if (isMedicare || isMedicaid || isGlobal) {
                return <Button bsStyle='link' onClick={() => this.handleGetDocumentation('hospital')}>Hospital Charges</Button>;
            }

            if (!isSbs && !isMedicare && !isMedicaid && !isGlobal) {
                return <Button bsStyle='link' onClick={() => this.handleGetDocumentation('hospital')}>Medicare Cost Report</Button>;
            }
        }

        return null;
    }

    render = () => {
        const documentationLinks = this.getDocumentationLinks();
        const statusDescription = this.getStatusDescription();
        const { allowAction, isAdmin } = this.props;

        return (
            <tr style={{ backgroundColor: this.props.backgroundColor, height: 51 }}>
                <td style={{ textAlign: 'left' }}>{this.props.chargeDescription}</td>
                <td>&nbsp;</td>
                <td>{this.props.chargeAmount}</td>
                <td>{documentationLinks}</td>
                <td>
                    {allowAction || isAdmin ?
                        <Action
                            status={this.props.status}
                            onStatusChange={this.handleStatusChange}
                        />
                        :
                        <>{statusDescription}</>
                    }
                </td>
            </tr>
        );
    }
}

export default ViewChargesTableRow;